import { configureStore } from "@reduxjs/toolkit";
import influencersSlice from "./influencersSlice";
import usersSlice from "./usersSlice";

export const store = configureStore({
  reducer: {
    users: usersSlice,
    influencers: influencersSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
